export default __webpack_public_path__ + "static/media/blue_back.82702bec.svg";